import React from "react";
import { useContext } from 'react';
import Button from "../components/Button";
import CustomeIcon from "../components/CustomeIcon";
import cartContext from "../store/cart-context";

const MyAppliances = (props) => {
  const cartCtx = useContext(cartContext);
  console.log('MyAppliances cartCtx', cartCtx.items)
  console.log("onclick of the return to kitchen btn",props.clickFunc);
  return (
    <>
      <h1>Your Kitchen Appliances</h1>
      {cartCtx?.items?.map((cardItem, card_index) => {
        return (
          <div className="mykitchenItem d-flex" key={cardItem.title}>
            <div className="reviewCartImg">
              <CustomeIcon
                src={cardItem.thumbnail}
                alt={cardItem.title}
                classList=""
              ></CustomeIcon>
            </div>

            <div className="kitchenDescripImg">
              <p>{cardItem.description}</p>
              <Button classList="removeBtn" data={cardItem.title} clickFunction={cartCtx.removeItem}>Remove</Button>
            </div>
          </div>
        );
      })}

      <div className="reviewCartBtn">
        <Button classList="returnToKitchenBtn" clickFunction={props.clickFunc}>RETURN TO KITCHEN</Button>
        <Button classList="proceedToCheckoutBtn">PROCEED TO CHECKOUT</Button>
      </div>
    </>
  );
};

export default MyAppliances;
